import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

export default (baseURL: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL,
		clientId,
		isApp: true, 
		hasUnderMaintenance: false
	});

	const sendContract = (contractId: number) => {
		const serviceUrl = `/bookbuilding-api/Afin/LoadDataToAfin`;
		return api.post(serviceUrl,  [contractId])
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const createSignature = (idContract: number) => {
		const serviceUrl = `/bookbuilding-api/Signature/CreateSignature?IdContract=${idContract}`;
        return api.post(serviceUrl)
	};

	return {
		sendContract,
		createSignature
	};
};
